export const animationConfig = {
  mass: 10,
  tension: 1000,
  friction: 300,
  // Decreasing precision to improve performance from 0.00001
  precision: 0.1
};
